module.exports = __webpack_public_path__ + "img/title5.2127405f.png";